import PropTypes from 'prop-types';

export const ProductCategoryPropType = PropTypes.shape({
  categoryId: PropTypes.string,
  name: PropTypes.string,
  active: PropTypes.bool,
  productCount: PropTypes.number,
});

/**
 * @typedef {object} ProductCategoryPropType
 * @property {string} categoryId
 * @property {string} name
 * @property {boolean} active
 * @property {number} productCount
 */
